export default {
  text: {
    primary: '#263238',
    secondary: '#546E7A',
    link: '#1E88E5',
  },
};
